import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'
const routes = [
  route('index', '/index', DashboardProfessional, meta('Dashboard profissional', true, 'guest'))
]

export default subGroup('/dashboard/professional', routes)



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/routes.js